import {Box, styled} from '@mui/material';

const SpinnerContainer = styled(Box)({
    flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
});

export default SpinnerContainer;